import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const setHreflangTags = () => {
    const base = window.location.origin + window.location.pathname.replace(/\/$/, '');
    const tags = [
        { hreflang: 'de', href: base + '/' },
        { hreflang: 'en', href: base + '/?lang=en' },
        { hreflang: 'x-default', href: base + '/' },
    ];
    tags.forEach(({ hreflang, href }) => {
        let tag = document.querySelector(`link[hreflang="${hreflang}"]`);
        if (!tag) {
            tag = document.createElement('link');
            tag.rel = 'alternate';
            tag.setAttribute('hreflang', hreflang);
            document.head.appendChild(tag);
        }
        tag.href = href;
    });
};

export const useMetaTags = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        const desc = document.querySelector('meta[name="description"]');
        if (desc) {
            desc.content = t('meta.description');
        }
        document.title = t('meta.title');
        document.documentElement.lang = i18n.language.startsWith('de') ? 'de' : 'en';
        setHreflangTags();
    }, [t, i18n.language]);
};
